import script from "./FeatureCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureCard.vue?vue&type=script&setup=true&lang=js"

import "./FeatureCard.vue?vue&type=style&index=0&id=76a9925f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a9925f"]])

export default __exports__